module.exports = __webpack_public_path__ + "static/media/header-image.453d7cac.png";